import styled from "styled-components";

import { FlashPCBTable, SCROLLBAR_STYLES } from "../../../constants/Styles";

export const Body = styled.div`
  overflow-x: scroll;
  white-space: nowrap;
  width: 100%;
  ${SCROLLBAR_STYLES};
`;

export const HorizontalRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
`;

export const PaginationContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: center;
`;

export const SearchOptionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const PartsTable = styled(FlashPCBTable)`
  display: inline-block;
`;

export const NoResults = styled.div`
  padding: 1rem;
  text-align: center;
`;

export const Filters = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const TextArea = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  margin-left: 1rem;
  gap: 1rem;
`;

export const SearchHeader = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const InStockPartsLink = styled.div`
  display: flex;
  align-items: center;
`;

export const FiltersHeader = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const FiltersContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: row;
  overflow-x: scroll;
  ${SCROLLBAR_STYLES};
`;

export const FootprintCell = styled.div`
  padding: 0.5rem;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  align-items: center;
`;
